import React, { useEffect } from 'react';

import { ConfluencePromptSuggestions } from '@confluence/smart-create/entry-points/ConfluencePromptSuggestions.ts';

const LoadPromptSuggestions = ({
	requested,
	loadSuggestions,
}: {
	requested: boolean;
	loadSuggestions: () => Promise<void>;
}) => {
	useEffect(() => {
		if (requested) void loadSuggestions();
	}, [requested, loadSuggestions]);
	return null;
};

export const SmartCreatePromptSuggestionsPreloader = ({
	requested,
}: {
	requested: boolean;
}): React.JSX.Element => (
	<ConfluencePromptSuggestions touchpointSource="smart-create-preload-prompt-suggestions">
		{({ loadSuggestions }) => (
			<LoadPromptSuggestions requested={requested} loadSuggestions={loadSuggestions} />
		)}
	</ConfluencePromptSuggestions>
);
